import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { CharacterEditorSelectableItem } from "./CharacterEditorSelectableItem";
import { getAllCharacterSkinVariantNames } from "../../helper/spineHelper";
import { CharacterSelectionHelper } from "../../helper/CharacterSelectionHelper";
import { TabBorderColor } from "../game/ui components/GameUIElements";
import { CharacterEditorChangeGroup, groupUndoableCharacterEditorChanges } from "../../stores/undo/operation/CharacterEditorSubmitCharacterConfigurationChangesOp";
import { translationStore } from "../../stores/TranslationStore";
import { gameStore } from "../../stores/GameStore";
const Container = styled.div.withConfig({
  displayName: "SelectionComponentSkinVariant__Container",
  componentId: "sc-1uoa5f0-0"
})(["display:flex;flex-direction:column;flex-grow:1;background-color:#000000;align-items:center;width:180px;padding-top:16px;overflow:auto;transition:transform 0.33s ease;&.hidden{border:0;visibility:hidden;transform-origin:left;transform:scaleX(0%);}&.shown{border-right:", " 4px solid;border-top:", " 4px solid;border-bottom:", " 4px solid;visibility:visible;transform-origin:left;transform:scaleX(100%);}"], TabBorderColor, TabBorderColor, TabBorderColor);
const VariantButtonContainer = styled(CharacterEditorSelectableItem).withConfig({
  displayName: "SelectionComponentSkinVariant__VariantButtonContainer",
  componentId: "sc-1uoa5f0-1"
})(["display:block;width:155px;height:60px;"]);
export const SelectionComponentSkinVariant = observer(props => {
  var _animationStore$selec, _animationStore$selec2, _animationStore$selec3, _animationStore$selec4;

  const animationStore = props.store.animationSelectionStore;
  const allVariants = getAllCharacterSkinVariantNames((_animationStore$selec = animationStore.selectedAnimation) === null || _animationStore$selec === void 0 ? void 0 : (_animationStore$selec2 = _animationStore$selec.spine) === null || _animationStore$selec2 === void 0 ? void 0 : (_animationStore$selec3 = _animationStore$selec2.skeleton) === null || _animationStore$selec3 === void 0 ? void 0 : (_animationStore$selec4 = _animationStore$selec3.data) === null || _animationStore$selec4 === void 0 ? void 0 : _animationStore$selec4.skins, animationStore.selectedSkinClass);

  function onToggleSkinVariant(skinClassName, skinVariantName) {
    groupUndoableCharacterEditorChanges(CharacterEditorChangeGroup.UnspecificGroupedChanges, () => {
      const selectedConfig = props.store.selectedCharacterConfiguration;
      CharacterSelectionHelper.constrainedToggle(selectedConfig, allVariants, skinClassName, skinVariantName);
    });
  }

  return /*#__PURE__*/React.createElement(Container, {
    className: props.isShown ? "shown" : "hidden"
  }, allVariants.map(name => /*#__PURE__*/React.createElement(VariantButtonContainer, {
    key: name,
    className: props.store.selectedCharacterConfiguration.isSkinActive(animationStore.selectedSkinClass, name) ? "selected" : "",
    onClick: () => {
      onToggleSkinVariant(animationStore.selectedSkinClass, name);
    }
  }, translationStore.makeshiftTranslationSystemData.characterSkinVariantOptions.getTranslation(gameStore.languageKey, name))));
});